/* eslint-disable */
import { PluginContainerData, Oembed } from './common.js';

export interface EmbedData {
  /** Styling for the oEmbed node's container. */
  containerData?: PluginContainerData;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: Oembed;
  /** Origin asset source. */
  src?: string;
}

const baseEmbedData: object = {};

export const EmbedData = {
  fromJSON(object: any): EmbedData {
    const message = { ...baseEmbedData } as EmbedData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.oembed =
      object.oembed !== undefined && object.oembed !== null
        ? Oembed.fromJSON(object.oembed)
        : undefined;
    message.src =
      object.src !== undefined && object.src !== null
        ? String(object.src)
        : undefined;
    return message;
  },

  toJSON(message: EmbedData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.oembed !== undefined &&
      (obj.oembed = message.oembed ? Oembed.toJSON(message.oembed) : undefined);
    message.src !== undefined && (obj.src = message.src);
    return obj;
  },
};
